import { render, staticRenderFns } from "./dataSummaryScreenYuanshiTow.vue?vue&type=template&id=0d1fdfac&scoped=true&"
import script from "./dataSummaryScreenYuanshiTow.vue?vue&type=script&lang=js&"
export * from "./dataSummaryScreenYuanshiTow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1fdfac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1fdfac')) {
      api.createRecord('0d1fdfac', component.options)
    } else {
      api.reload('0d1fdfac', component.options)
    }
    module.hot.accept("./dataSummaryScreenYuanshiTow.vue?vue&type=template&id=0d1fdfac&scoped=true&", function () {
      api.rerender('0d1fdfac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dataSummaryScreenYuanshiTow.vue"
export default component.exports